import React from 'react';
import { Box } from '@mui/material';
import { createSx } from '../../utils';
//eslint-disable-next-line no-restricted-imports
import animatedLogo from './animations/animated-logo.svg?url';

const sx = createSx({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'neutral.fixed'
  },
  loader: {
    width: 200,
    height: 200,
  },
});

const Preloader = () => {
  return (
    <Box sx={sx.root}>
      <Box
        component='img'
        sx={sx.loader}
        role='progressbar'
        aria-label='Application loading'
        src={animatedLogo}
      >
      </Box>
    </Box>
  );
};

export default Preloader;
